import * as Yup from "yup";

const preferencesValidationSchema = Yup.object().shape({
  learnerCapacity: Yup.object().shape({
    maximum: Yup.number()
      .typeError("Please set capacity")
      .min(0, "Please set capacity")
      .required("Please set capacity"),
  }),
});

export default preferencesValidationSchema;
